export var singletons = {
    legacyApiToken:null,
};